export default {
  sidebar: {
    dashboard: 'Tableau de bord',
    prescriptions: 'Prescriptions',
    consultations: 'Consultations',
    appointments: 'Rendez-vous',
    messages: 'Messagerie',
    medicalRecords: 'Dossiers médicaux',
    notifications: 'Notifications',
    settings: 'Paramètres',
    profile: 'Profil',
    security: 'Sécurité',
    logout: 'Déconnexion',
    adminPanel: 'Administration',
    doctors: 'Médecins',
    patientRecords: 'Dossiers Patients',
    colleagues: 'Confrères',
    users: 'Utilisateurs',
    services: 'Services & Offres',
    financials: 'Rapports Financiers',
    moderation: 'Modération Consultations',
    monitoring: 'Surveillance Système',
    communications: 'Communications & Diffusion',
    permissions: 'Permissions & Droits',
    dataExport: 'Sauvegardes & Exports',
    elitePlatform: 'Plateforme Elite',
    closeMenu: 'Fermer le menu',
    mainMenu: 'Menu principal',
    mainNavigation: 'Navigation principale',
    healthLevel: 'Niveau Santé',
    onlineCabinet: 'Cabinet En Ligne',
    currentStatus: 'Statut Actuel',
    healthRanks: {
      elite: 'Patient Elite',
      adept: 'Adepte Santé',
      initiate: 'Initié Santé'
    },
    offline: 'HORS-LIGNE'
  },
  header: {
    search: 'Rechercher...',
    notifications: 'Notifications',
    profile: 'Mon Profil',
    logout: 'Déconnexion'
  },
  topbar: {
    openNavigation: 'Ouvrir le menu de navigation',
    onlinePractitioners_one: '{{count}} PRATICIEN',
    onlinePractitioners_other: '{{count}} PRATICIENS',
    unreadMessages_one: '{{count}} message non lu',
    unreadMessages_other: '{{count}} messages non lus',
    unreadNotifications_one: '{{count}} alerte médicale',
    unreadNotifications_other: '{{count}} alertes médicales'
  },
  userMenu: {
    title: 'Menu utilisateur',
    open: 'Ouvrir le menu utilisateur',
    profile: 'Profil',
    settings: 'Paramètres',
    logout: 'Déconnexion'
  },
  dashboardSidebar: {
    messages: 'Messagerie',
    notifications: 'Notifications',
    onlineUsers: 'Utilisateurs en ligne',
    alerts: 'Alertes',
    online: 'En Ligne',
    close: 'Fermer'
  },
  languages: {
    fr: 'Français',
    en: 'English'
  },
  presence: {
    title: 'Utilisateurs en ligne',
    loading: 'Chargement...',
    retry: 'Réessayer',
    teamOnline: 'Équipe en ligne',
    memberCount_one: '{{count}} Membre',
    memberCount_other: '{{count}} Membres',
    refresh: 'Actualiser',
    noUsers: 'Aucun utilisateur en ligne',
    rolePractitioner: 'Praticien',
    rolePatient: 'Patient',
    lastSeenJustNow: "À l'instant",
    lastSeenMins: 'Il y a {{count}}min',
    lastSeenHours: 'Il y a {{count}}h',
    lastSeenUnknown: 'Inconnu',
    defaultDoctorName: 'Médecin',
    defaultPatientName: 'Patient',
    availableDoctors: 'Médecins disponibles ({{count}})',
    noDoctorsAvailable: 'Aucun médecin disponible',
    onlinePatients: 'Patients en ligne ({{count}})',
    noPatientsOnline: 'Aucun patient en ligne',
    statusOnline: 'En ligne'
  },
  feedback: {
    error: 'Erreur lors de la navigation vers {{target}}',
    home: 'Accueil',
    close: 'Fermer',
    navigating: 'Navigation',
    back: 'Retour',
    refresh: 'Actualiser'
  }
};
